<div *ngIf="instance.id.length > 0">
  <div class="get-project-content">
    <div class="action-buttons-header">
      <a class="ou-get-back" (click)="back()">
        <mat-icon class="material-icons-outlined">arrow_back_ios</mat-icon>
        <div class="ou-get-back-title">{{instance.organizationUnit.niceName}}</div>
      </a>
      <app-button
        [title]="'Frissítés'"
        [icon]="'sync'"
        [fontSize]="18"
        [customColor]="'green'"
        (click)="refresh()"
      ></app-button>
      <app-button
        [style]="{ marginLeft: '10px' }"
        *ngIf="hasSettingsBtn"
        [title]="'Projekt beállítások'"
        [icon]="'edit'"
        [fontSize]="18"
        [customColor]="'yellow'"
        (click)="edit()"
      ></app-button>
    </div>
    <div class="project-header-container">
      <div class="project-header-item">
        <div class="project-header-item-data">Projekt:</div>
        <div class="project-header-item-data">{{instance.name}}</div>
      </div>
      <div class="project-header-item">
        <div class="project-header-item-data">Szervezeti egység:</div>
        <div class="project-header-item-data">{{instance.organizationUnit.niceName}}</div>
      </div>
      <div class="project-header-item">
        <div class="project-header-item-data">Létrehozva:</div>
        <div class="project-header-item-data">{{this.instance.createdAt.toLocaleDateString().split('/').reverse().join('-')}}</div>
      </div>
      <div class="project-header-item">
        <div class="project-header-item-data">Létrehozta:</div>
        <div class="project-header-item-data">{{instance.createdBy.firstName}} {{instance.createdBy.lastName}}</div>
      </div>
    </div>
    <div class="project-content">
      <app-list-ticket [refSubject]=refSubject [project]="instance"></app-list-ticket>
    </div>
  </div> 
</div>
